module.exports = __webpack_public_path__ + "media/images/recruitment/designs/alpha-phi-dot-bg-d8e1246b37a9dd31df136495edc447ef.jpg";